(() => {
  class TestimonialsSlider {
    constructor(root) {
      this.track = root.querySelector('[data-tst-track]');
      this.prev = root.querySelector('[data-tst-prev]');
      this.next = root.querySelector('[data-tst-next]');
      this.prev?.addEventListener('click', () => this.scrollBy(-1));
      this.next?.addEventListener('click', () => this.scrollBy(1));
      this.track?.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());
      this.update();
    }

    step() {
      const card = this.track?.querySelector('[data-tst-card]');
      if (!card || !this.track) return 320;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    scrollBy(direction) {
      this.track?.scrollBy({ left: this.step() * direction, behavior: 'smooth' });
    }

    update() {
      if (!this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }
  }

  const init = () => {
    document.querySelectorAll('[data-testimonials]').forEach((root) => {
      if (root.dataset.tstReady) return;
      root.dataset.tstReady = 'true';
      new TestimonialsSlider(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
